import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { useTagsViewStore } from '@/stores/tagsView'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', noTagsView: true },
  },
  {
    path: '/redirect/:path(.*)*',
    name: 'Redirect',
    component: () => import('@/views/Redirect.vue'),
    meta: { title: '跳转中', noTagsView: true },
  },
  {
    path: '/',
    component: () => import('@/shared/layout/Index.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: '/comics/library',
        name: 'ComicLibrary',
        component: () => import('@/views/comics/ComicList.vue'),
        meta: {
          title: '漫画库',
          icon: 'Document',
          breadcrumb: [{ title: '漫画管理' }, { title: '漫画库' }],
        },
      },
      {
        path: '/comics/statistics',
        name: 'ComicStatistics',
        component: () => import('@/views/comics/ComicStatistics.vue'),
        meta: {
          title: '漫画统计',
          icon: 'DataAnalysis',
          breadcrumb: [{ title: '漫画管理' }, { title: '漫画统计' }],
        },
      },
      {
        path: '/comics/statistics/:id',
        name: 'ComicVolStatistics',
        component: () => import('@/views/comics/ComicVolStatistics.vue'),
        meta: {
          title: '卷看板',
          icon: 'DataAnalysis',
          activeMenu: '/comics/statistics',
          breadcrumb: [
            { title: '漫画管理' },
            { title: '漫画统计', path: '/comics/statistics' },
            { title: '卷看板' },
          ],
        },
      },
      {
        path: '/comics/:id',
        name: 'ComicDetail',
        component: () => import('@/views/comics/ComicDetail.vue'),
        meta: {
          title: '漫画详情',
          icon: 'Document',
          activeMenu: '/comics/library',
          breadcrumb: [
            { title: '漫画管理' },
            { title: '漫画库', path: '/comics/library' },
            { title: '漫画详情' },
          ],
        },
      },
      {
        path: '/users',
        name: 'Users',
        component: () => import('@/views/users/UserList.vue'),
        meta: {
          title: '用户管理',
          icon: 'User',
          breadcrumb: [{ title: '用户管理' }],
        },
      },
      {
        path: '/users/behavior',
        name: 'BehaviorRecord',
        component: () => import('@/views/users/BehaviorRecord.vue'),
        meta: {
          title: '用户行为',
          icon: 'Monitor',
          breadcrumb: [{ title: '监控中心' }, { title: '用户行为' }],
        },
      },
      {
        path: '/users/:id',
        name: 'UserDetail',
        component: () => import('@/views/users/UserDetail.vue'),
        meta: {
          title: '用户详情',
          icon: 'User',
          activeMenu: '/users',
          breadcrumb: [
            { title: '用户管理', path: '/users' },
            { title: '用户详情' },
          ],
        },
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: {
          title: '流量监控',
          icon: 'DataBoard',
          affix: true,
          breadcrumb: [{ title: '监控中心' }, { title: '流量监控' }],
        },
      },
      {
        path: '/dashboard/province',
        name: 'DistributionStatistics',
        component: () => import('@/views/dashboard/DistributionStatistics.vue'),
        meta: {
          title: '流量分布',
          icon: 'MapLocation',
          breadcrumb: [{ title: '监控中心' }, { title: '流量分布' }],
        },
      },
      {
        path: '/dashboard/cache',
        name: 'CacheMonitor',
        component: () => import('@/views/dashboard/CacheMonitor.vue'),
        meta: {
          title: '缓存监控',
          icon: 'Box',
          breadcrumb: [{ title: '监控中心' }, { title: '缓存监控' }],
        },
      },
      {
        path: '/news/article',
        name: 'NewsArticleList',
        component: () => import('@/views/news/NewsArticleList.vue'),
        meta: {
          title: '资讯稿件',
          icon: 'Document',
          breadcrumb: [{ title: '漫画资讯' }, { title: '资讯稿件' }],
        },
      },
      {
        path: '/news/article/create',
        name: 'NewsArticleCreate',
        component: () => import('@/views/news/NewsArticleCreate.vue'),
        meta: {
          title: '新增资讯',
          icon: 'Document',
          activeMenu: '/news/article',
          breadcrumb: [
            { title: '漫画资讯' },
            { title: '资讯稿件', path: '/news/article' },
            { title: '新增资讯' },
          ],
        },
      },
      {
        path: '/news/article/:id',
        name: 'NewsArticleDetail',
        component: () => import('@/views/news/NewsArticleDetail.vue'),
        meta: {
          title: '资讯详情',
          icon: 'Document',
          activeMenu: '/news/article',
          breadcrumb: [
            { title: '漫画资讯' },
            { title: '资讯稿件', path: '/news/article' },
            { title: '资讯详情' },
          ],
        },
      },
      {
        path: '/news/banner',
        name: 'NewsBannerList',
        component: () => import('@/views/news/NewsBannerList.vue'),
        meta: {
          title: '资讯 Banner',
          icon: 'Picture',
          breadcrumb: [{ title: '漫画资讯' }, { title: '资讯 Banner' }],
        },
      },
      {
        path: '/news/banner/create',
        name: 'NewsBannerCreate',
        component: () => import('@/views/news/NewsBannerCreate.vue'),
        meta: {
          title: '新增资讯 Banner',
          icon: 'Picture',
          activeMenu: '/news/banner',
          breadcrumb: [
            { title: '漫画资讯' },
            { title: '资讯 Banner', path: '/news/banner' },
            { title: '新增资讯 Banner' },
          ],
        },
      },
      {
        path: '/news/banner/:id',
        name: 'NewsBannerDetail',
        component: () => import('@/views/news/NewsBannerDetail.vue'),
        meta: {
          title: '资讯 Banner 详情',
          icon: 'Picture',
          activeMenu: '/news/banner',
          breadcrumb: [
            { title: '漫画资讯' },
            { title: '资讯 Banner', path: '/news/banner' },
            { title: '资讯 Banner 详情' },
          ],
        },
      },
      {
        path: '/home/banner',
        name: 'BannerManage',
        component: () => import('@/views/banners/BannerManage.vue'),
        meta: {
          title: '首页 Banner',
          icon: 'Picture',
          breadcrumb: [{ title: '首页配置' }, { title: '首页 Banner' }],
        },
      },
      {
        path: '/home/banner/frames/:id',
        name: 'BannerFrameDetail',
        component: () => import('@/views/banners/BannerFrameDetail.vue'),
        meta: {
          title: '轮播屏详情',
          icon: 'Picture',
          activeMenu: '/home/banner',
          breadcrumb: [
            { title: '首页配置' },
            { title: '首页 Banner', path: '/home/banner' },
            { title: '轮播屏详情' },
          ],
        },
      },
      {
        path: '/tips/amount',
        name: 'TipAmountList',
        component: () => import('@/views/tips/TipAmountList.vue'),
        meta: {
          title: '打赏金额',
          icon: 'Money',
          breadcrumb: [{ title: '打赏管理' }, { title: '打赏金额' }],
        },
      },
      {
        path: '/tips/amount/:id',
        name: 'TipAmountDetail',
        component: () => import('@/views/tips/TipAmountDetail.vue'),
        meta: {
          title: '打赏金币详情',
          icon: 'Money',
          activeMenu: '/tips/amount',
          breadcrumb: [
            { title: '打赏管理' },
            { title: '打赏金额', path: '/tips/amount' },
            { title: '打赏金币详情' },
          ],
        },
      },
      {
        path: '/pay/gold-package',
        name: 'GoldPackageList',
        component: () => import('@/views/pay/GoldPackageList.vue'),
        meta: {
          title: '充值档位',
          icon: 'Wallet',
          breadcrumb: [{ title: '付费管理' }, { title: '充值档位' }],
        },
      },
      {
        path: '/pay/gold-package/:id',
        name: 'GoldPackageDetail',
        component: () => import('@/views/pay/GoldPackageDetail.vue'),
        meta: {
          title: '充值档位详情',
          icon: 'Wallet',
          activeMenu: '/pay/gold-package',
          breadcrumb: [
            { title: '付费管理' },
            { title: '充值档位', path: '/pay/gold-package' },
            { title: '充值档位详情' },
          ],
        },
      },
      {
        path: '/pay/vol-unlock',
        name: 'VolUnlockList',
        component: () => import('@/views/pay/VolUnlockList.vue'),
        meta: {
          title: '解锁记录',
          icon: 'Tickets',
          breadcrumb: [{ title: '付费管理' }, { title: '解锁记录' }],
        },
      },
      {
        path: '/pay/agreement',
        name: 'AgreementManage',
        component: () => import('@/views/pay/AgreementManage.vue'),
        meta: {
          title: '内容协议',
          icon: 'Notebook',
          breadcrumb: [{ title: '付费管理' }, { title: '内容协议' }],
        },
      },
      {
        path: '/orders',
        name: 'OrderList',
        component: () => import('@/views/orders/OrderList.vue'),
        meta: {
          title: '交易订单',
          icon: 'CreditCard',
          breadcrumb: [{ title: '交易管理' }, { title: '交易订单' }],
        },
      },
      {
        path: '/orders/:id',
        name: 'OrderDetail',
        component: () => import('@/views/orders/OrderDetail.vue'),
        meta: {
          title: '交易订单详情',
          icon: 'CreditCard',
          activeMenu: '/orders',
          breadcrumb: [
            { title: '交易管理' },
            { title: '交易订单', path: '/orders' },
            { title: '交易订单详情' },
          ],
        },
      },
      {
        path: '/feedback',
        name: 'FeedbackList',
        component: () => import('@/views/feedback/FeedbackList.vue'),
        meta: {
          title: '反馈列表',
          icon: 'ChatDotRound',
          breadcrumb: [{ title: '用户反馈' }, { title: '反馈列表' }],
        },
      },
      {
        path: '/feedback/:id',
        name: 'FeedbackDetail',
        component: () => import('@/views/feedback/FeedbackDetail.vue'),
        meta: {
          title: '反馈详情',
          icon: 'ChatDotRound',
          activeMenu: '/feedback',
          breadcrumb: [
            { title: '用户反馈' },
            { title: '反馈列表', path: '/feedback' },
            { title: '反馈详情' },
          ],
        },
      },
      {
        path: '/system/switch',
        name: 'SystemSwitch',
        component: () => import('@/views/system/SystemSwitch.vue'),
        meta: {
          title: '系统切换',
          icon: 'Setting',
          breadcrumb: [{ title: '系统管理' }, { title: '系统切换' }],
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  const tagsViewStore = useTagsViewStore()

  if (to.path === '/login') {
    tagsViewStore.reset()
  }

  if (to.meta.title) {
    document.title = `橘子漫嘎后台 - ${to.meta.title}`
  }

  if (to.meta.requiresAuth && !userStore.isLoggedIn) {
    next('/login')
  } else if (to.path === '/login' && userStore.isLoggedIn) {
    next('/')
  } else {
    next()
  }
})

export default router

